import React from 'react';
import { EntityDetailFetcher } from '../components/EntityDetailFetcher';
import typeIntro from '../static/introspection/Trend360.json';
import { ENTITY } from '../utils/entities';
import { Trend360DetailQuery } from 'graphql/query/Trend360DetailQuery';
import { Entity360Actions } from '../components/Entity360Actions';
import { StatusSetter } from '../components/StatusSetter';
import { setTrend360StatusMutation } from '../graphql/mutations/setTrend360StatusMutation';
import Status360Introspection from '../static/introspection/Status360.json';
import {
	TREND360_DETAIL_FIELDS,
	trend360DetailTransformer,
} from 'utils/entities/trend360';

const statuses = Status360Introspection.enumValues.map((o) => o.name);

export const Trend360Detail = ({ id }) => (
	<EntityDetailFetcher
		id={id}
		query={Trend360DetailQuery}
		entityName={ENTITY.TREND_360}
		typeIntro={typeIntro}
		clonable={false}
		// IMPORTANT - le relazioni si modificano fuori dalla mutation dell'entita'
		// (form di modifica e dialogo "Dati e relazioni" scrivono Relationships360):
		// senza network-only la cache di Apollo ripropone le liste pre-modifica
		disableCache={true}
		customActionComponents={(entity) => [
			<StatusSetter
				key="status"
				statuses={statuses}
				entityName={ENTITY.TREND_360}
				entity={entity}
				statusFieldName="status"
				mutation={setTrend360StatusMutation}
				entityIntrospection={typeIntro}
			/>,
			<Entity360Actions
				key="actions"
				entity={entity}
				entityName={ENTITY.TREND_360}
			/>,
		]}
		fields={TREND360_DETAIL_FIELDS as string[]}
		transformer={trend360DetailTransformer}
	/>
);
